import type { GlobalApplicationsPersonalMenuPersonalMenuDto } from '@ori/global-api-client-react';

import type { MenuItem } from '../schemas/menuItemSchema';

export const mapCustomerMenuToInternalMenuItems = (
  parentItemPath: string,
  items: GlobalApplicationsPersonalMenuPersonalMenuDto['items'],
): MenuItem[] =>
  items.reduce<MenuItem[]>((accumulatedValue, item, index) => {
    const { url, isViewable, title, icon, openInNewTab, subItems } = item;

    // Ignore items without title or url
    if (!title || !url) {
      return accumulatedValue;
    }

    const itemPath = `${parentItemPath}/${index}/`;
    const mappedItem: MenuItem = {
      itemPath,
      title,
      url,
      icon: icon ?? null,
      openInNewTab: openInNewTab ?? null,
      subItems: mapCustomerMenuToInternalMenuItems(itemPath, [
        ...(subItems.length && url && isViewable
          ? [
              {
                url,
                title,
                isViewable: true,
                subItems: [],
              },
            ]
          : []),
        ...subItems,
      ]),
      isViewable,
    };

    accumulatedValue.push(mappedItem);

    return accumulatedValue;
  }, []);
